import React from "react";
import Typography from "@mui/material/Typography";

function SobreSGIO() {
	return (
		<>
			<h1>Sobre o SGIO</h1>
			<hr />

			<div className="row d-flex justify-content-center">
				<div className="about col-md-4 mx-4 mt-5">
					<Typography component="p" >
						O SGIO ─ Sistema de Diagnóstico do Grau de Inovação das
						Organizações ─ busca mensurar o grau de inovação de uma
						organização, numa escala de 1 a 5, com base em 12
						respostas a quesitos envolvendo estratégias
						metodológicas para inovação; geração e gestão da
						Propriedade Intelectual (PI) e Transferência de
						Tecnologia (TT); ações de inovação organizacional;
						investimento para geração de conhecimento e o perfil do
						gestor, totalizando 5 dimensões.
					</Typography>
				</div>
				<div className="about col-md-4 mx-4 mt-5">
					<Typography component="p">
						Resulta em relatório contendo o Grau de Inovação (GI) por cada dimensão, o GI total, uma análise de criticidade também por cada dimensão, classificada em Alta, Média ou Baixa, além dos pontos fortes da Organização em termos de inovação. O SGIO também disponibiliza histórico dos cálculos, registrando a evolução do processo de inovação nas Organizações, com gráfico comparativo tanto para o GI de cada dimensão, quanto para o GI total.
					</Typography>
				</div>

				<div className="col-12 text-center">
					<Typography className="fs-1 my-5">
						Inovar torna a organização mais moderna, produtiva e
						competitiva.
					</Typography>
				</div>
			</div>
		</>
	);
}

export default SobreSGIO;
